import { oPopupBorderTop, oPopupPadding } from '@approvalmax/ui';
import { ui } from 'modules/common';
import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    flex-flow: column;
    ${oPopupBorderTop()}
    ${oPopupPadding()}
`;

export const Desciption = styled.div`
    flex: none;
`;

export const CommentEditor = styled(ui.AddCommentEditor)`
    margin-top: 40px;
`;
